module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-14.613d17a5.png";